import { FilePurpose } from '@/api/enums';
import { isKeycloakEnabled } from '@/auth';
import { client } from '@/client';
import { FileUpload, FileUploadUploadEvent } from 'primereact/fileupload';
import React from 'react';
import { useAuth } from 'react-oidc-context';
import styled from 'styled-components';

const StyledFileUpload = styled(FileUpload)`
  &.file-upload {
    > .p-button.p-component.p-fileupload-choose {
      padding: var(--medium-padding) var(--small-padding);
      width: 100%;
      border: 0;
      background-color: transparent;
      color: var(--black-main);
      text-align: left;
      border-radius: 0;

      &:hover {
        color: var(--black-main) !important;
        border-color: var(--gray-pale) !important;
        background: var(--gray-pale) !important;
      }

      .p-button-label {
        font-weight: 400;
      }
    }
  }

  &.button {
    > .p-button.p-component.p-fileupload-choose {
      flex-shrink: 0;
      font-size: var(--small-font-size);
      line-height: var(--small-line-height);
      background: var(--red-dark);
      color: var(--white-main);
      border: 1px solid var(--red-main);
      border-radius: var(--default-border-radius);
      padding: 10px var(--default-padding);
      height: var(--default-input-height);
      overflow: hidden;
      flex-direction: row-reverse;
      gap: var(--xsmall-padding);
    }
  }
`;

type UsersImportFileUploadProps = {
  className: 'button' | 'file-upload';
  chooseLabel: string;
  chooseIcon?: React.ReactNode;
  isUploading: boolean;
  onUploaded: (fileId: string) => void;
  resetDialogData?: () => void;
  onDoNotShowAgain?: () => void;
};

export const UsersImportFileUpload: React.FC<UsersImportFileUploadProps> = ({
  className,
  chooseLabel,
  chooseIcon,
  isUploading,
  onUploaded,
  resetDialogData,
  onDoNotShowAgain,
}) => {
  const { user } = useAuth();
  const isKeycloakAuth = isKeycloakEnabled();

  return (
    <StyledFileUpload
      className={className}
      mode="basic"
      name="file"
      url={client.files.getFileUploadUrl()}
      accept="text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      maxFileSize={5e6}
      onUpload={(event: FileUploadUploadEvent) => {
        try {
          const response = JSON.parse(event.xhr.response);
          onUploaded(response.id);
        } catch (error) {
          return;
        }

        onDoNotShowAgain?.();
        resetDialogData?.();
      }}
      auto
      chooseOptions={{ label: chooseLabel, icon: chooseIcon }}
      disabled={isUploading}
      withCredentials
      onBeforeSend={(event) => {
        if (user && isKeycloakAuth) {
          event.xhr.setRequestHeader(
            'Authorization',
            `Bearer ${user?.access_token}`,
          );
        }
      }}
      onBeforeUpload={(event) => {
        event.formData.append('purpose', FilePurpose.IMPORT);
      }}
    />
  );
};
